import { Reveal, Overline, SectionTitle } from "./Reveal";

const STEPS = [
  ["Start a Spotter", "Open the app and start a new Spotter. You get a code — that's your account. No email, no password."],
  ["Bring your buddy", "Share the code. Your gym partner joins the same workout plan and meal plan in seconds."],
  ["Log every set", "Enter weight and reps for each set and tick it off. Spotter times your rest, and every exercise has demo photos, steps, form tips and a video."],
  ["Get stronger", "Watch your numbers climb, hit your milestones and keep showing up — together."],
];

export const HowItWorks = () => (
  <section id="how" className="border-t border-white/[0.07] bg-[#0b0c0f]">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-36">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal><Overline>How it works</Overline><SectionTitle className="mt-4">Four steps.<br />Zero <span className="text-grad">excuses.</span></SectionTitle></Reveal>
          <Reveal delay={0.1}><p className="mt-6 max-w-md text-base leading-relaxed text-[#b3b8c1]">The idea is simple: show up, put in the work, track your progress and keep improving.</p></Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7">
        {STEPS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.05}>
            <li data-testid={`how-step-${i + 1}`} className="group grid grid-cols-[4.5rem_1fr] gap-6 sm:grid-cols-[6rem_1fr] border-t border-white/10 py-10 sm:gap-10">
              <span className="font-display text-7xl font-black leading-none text-outline transition-colors duration-500 group-hover:text-[#ff6a3d] sm:text-8xl">0{i + 1}</span>
              <div>
                <h3 className="font-display text-3xl font-extrabold uppercase sm:text-4xl">{t}</h3>
                <p className="mt-3 max-w-md text-base leading-relaxed text-[#b3b8c1]">{d}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
